module.exports = "<div class=\"md-whiteframe-2dp reports\"> <div layout=row flex layout-padding layout-wrap layout-fill> <div layout=row class=\"md-whiteframe-3dp list-container\" flex=30 flex-xs=75 flex-sm=25 ng-repeat=\"student in studentList\" ng-click=gotoStudentSubjectReport(student.user_id)> <div layout=row flex layout-align=space-between> <i class=\"fas fa-user-circle\" style=font-size:25px></i> <b flex=85>{{student.name}}</b> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/authoring-tool/views/subjectStudentListing.html
// module id = 154
// module chunks = 462